import { Reveal } from "@/components/Reveal";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { useSite } from "@/context/SiteContext";

export default function CtaBand() {
  const { openQuote } = useSite();
  return (
    <section className="grain relative overflow-hidden border-t border-white/10 bg-ink-950 py-16 sm:py-32" data-testid="cta-band-section">
      <div className="absolute right-0 top-1/2 hidden -translate-y-1/2 select-none font-display text-[26rem] font-extrabold leading-none text-white/[0.03] lg:block" aria-hidden="true">
        B
      </div>
      <div className="container-brox relative">
        <Reveal>
          <p className="eyebrow mb-5">CA LA NOI, LA NIMENI.</p>
          <h2 className="display-title max-w-4xl text-5xl sm:text-7xl lg:text-8xl" data-testid="cta-band-title">
            Ai o lucrare<br />
            <span className="text-copper">de făcut?</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-paper/75 sm:text-lg" data-testid="cta-band-copy">
            Nu trebuie să cauți separat fiecare meseriaș. Spune-ne ce ai nevoie și noi organizăm soluția.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <button onClick={() => openQuote({ source: "cta-band" })} className="btn-primary copper-sheen mt-9" data-testid="cta-band-whatsapp">
            <WhatsAppIcon className="h-5 w-5" />
            CERE OFERTĂ PE WHATSAPP
          </button>
          <p className="mt-5 text-xs text-paper/60 sm:text-sm">Te contactăm în maximum 24 de ore.</p>
        </Reveal>
      </div>
    </section>
  );
}
